<template>
    <v-container grid-list-lg>
        <v-layout row wrap style="padding-bottom:20px"> 
               <v-loading class="loading" v-model="loading" v-if="loading">
    
                    <v-progress-circular persistent
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                    ></v-progress-circular>
            
                </v-loading>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Lista de comunicados</v-toolbar-title>
                    <v-btn v-if="perfil == 2 || perfil == 3" flat to="/criar-comunicado" outline color="white"  style="position:absolute; right:20px; top:7px">Novo</v-btn>
                </v-toolbar>
                <!--v-flex v-for="i in 10" :key="`4${i}`" xs12 sm8 md4-->
                <!--v-flex v-for="(fotografo, idx) in 10" :key="idx" xs12 sm8 md4-->
                <v-flex v-for="(item, index) in items" xs12 sm6 md4 row style="margin-bottom:20px; padding:0px">
                    
                    <v-card>
                        <img v-if="item.img != 'null'" :src="item.img" class="imagem" />
                        <v-card-text>
                            <v-btn class="deletar" v-if="perfil == 2 || perfil == 3" flat color="orange" flat="flat" @click="deletarItem(item.slug)">x</v-btn>
                            
                                <!--div class="imagem"  style="background-image: url('http://www.closebecoming.co.uk/images/category_10/Honey%20%20B%20Women%20Black%20Self%20Design%20Top%20Beautiful%20BLOVOT.jpg');" ></div-->
                                
                                <div style="width:100%" class="body-content">
                                    
                                    <h3 class="headline mb-0" :title="item.texto">{{item.texto}}</h3> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                                    
                                </div>

                            <v-card-actions>
                                <v-btn v-if="perfil == 2 || perfil == 3" class="editar" flat color="orange" flat="flat" @click="editarItem(item.slug)">Editar</v-btn>
                                <!--v-btn class="release" flat color="orange" flat="flat" @click="displayItem(item.slug)">Perfil</v-btn-->
                            </v-card-actions>
                            
                        </v-card-text>
                    
                    </v-card>
                </v-flex>
                
            

                
            
        </v-layout>
        <v-dialog v-model="dialogDeleteConfirm" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Deletar comunicado?</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="dialogDeleteConfirm = false">Não</v-btn>
                <v-btn color="green darken-1" flat @click="deletarItemConfirm">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Comunicado deletado com sucesso!</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import db from './firebaseInit';
import firebase from 'firebase';

import { userProperties } from '@/global.js'

export default {
    name: 'Comunicados-Listagem',
    data () {
        return {
            slug : '',
            dialogDeleteConfirm: false,
            dialog: false,
            loading: false,
            perfil: userProperties.perfil,
            modalMessage: 'Comunicado excluído com sucesso!',
            items: []
        }
    },
    methods: {
        carregaDados() {

            // ordernar exibicao - numerica
            function ordenarPorTimestamp(a, b){
                //return a.dataNumero - b.dataNumero; // crescente
                return b.ordenacao - a.ordenacao; // decrescente
            }

            this.items = []
            this.loading = true
            let obj = []
            
            db.collection("comunicados")
            .where("escolaID", "==", userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    this.loading = false;
                    alert("Nenhum comunicado foi criado.");
                }
                else{
                    querySnapshot.forEach(doc => {
                    
                        // doc.data() is never undefined for query doc snapshots
                        //console.log(doc.id, " => ", doc.data());                    
                        let customObj = doc.data()

                        var storageRef = firebase.storage().ref();
                        var tangRef = storageRef.child('comunicados/'+customObj.slug+'.'+customObj.extensao);

                        tangRef.getDownloadURL().then(urlImgFB =>                             {
                            // Once we have the download URL, we set it to our img element
                            //console.log(urlImgFB);
                            this.items.push({"texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "ordenacao":customObj.dateStart.replace(/-/g, ''), "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "extensao": customObj.extensao, "img": urlImgFB});
                            this.slug = customObj.slug;
                            this.items.sort(ordenarPorTimestamp)

                            }).catch(error => {
                                // If anything goes wrong while getting the download URL, log the error,
                                this.items.push({"texto": customObj.texto, "push": customObj.push, "preview": customObj.preview, "ordenacao":customObj.dateStart.replace(/-/g, ''), "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "img": "null"});
                                this.slug = customObj.slug;
                                this.items.sort(ordenarPorTimestamp)
                        });

                        this.loading = false

                    });

                }
                
            });
            console.log(this.items);
            // this.items = obj
            // console.log("XXXXXX"+obj)
        },
        editarItem(slug){
            this.$router.push(`/Editar-Comunicado/?slug=`+slug)

        },
        displayItem(slug){
            this.$router.push(`/Display-Comunicado/?slug=`+slug)

        },
        deletarItem(slug){
            this.slug = slug;
            this.dialogDeleteConfirm = true;
        },
        deletarItemConfirm(){
            var slug = this.slug;
            this.loading = true
            db.collection("comunicados").where("slug", "==", slug)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach((doc) => {
                    doc.ref.delete().then(() => {
                    this.dialog = true
                    console.log("Document successfully deleted!");
                    }).catch(function(error) {
                    console.error("Error removing document: ", error);
                    });
                });
                this.loading = false
                this.dialogDeleteConfirm = false;
                this.carregaDados();
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
                this.loading = false;
                this.dialogDeleteConfirm = false;
                alert("Error while trying to delete, please try again.");
            });
        },
        closeModal() {
            this.dialog = false      
            this.$router.push(`/`)
            this.$forceUpdate()
            Vue.delete(state.fixture, i)
        }
        
            
        
    },
    created() {
        this.carregaDados();
    }
};



</script>

<style scoped>
    .loading{
        position: fixed;
        top:20%;
        left:46%;
        z-index: 2;
    }

    .deletar{
        position: absolute;
        min-width: auto;
        height: auto;
        padding: 1px 6px !important;
        right: 0;
        top: 0;
    }

    .release{
        background-color:beige;
        position:absolute;
        right: 12px;
        display: none;
    }

    .editar{
        background-color:beige;
        position:absolute;
        right: 12px;
    }

    .imagem{
        width: 100%;
        height: auto;
    }

    .v-dialog--active .v-card__actions{
        height: 50px;
    }
    
</style>
